import config from '~/plugins/config';
import localeStorage from '~/plugins/i18n/store';
import { AppLocaleInfo } from './_types';
import { Locale } from '~/plugins/i18n/_types';

export const useAppLocale = () => {
    const { availableLocales } = config.app;

    const appLocales = computed<AppLocaleInfo[]>(() => {
        return availableLocales.map((locale) => ({
            label: locale.toUpperCase(),
            value: locale,
        }));
    });

    const setActiveLocale = async (locale: Locale) => {
        localeStorage.activeLocale.value = locale;
    };

    return {
        activeLocale: localeStorage.activeLocale,
        availableLocales,
        appLocales,
        setActiveLocale,
    };
};
